import { useAuth } from '@/hooks/useAuth';
import { useDashboard } from '@/hooks/useDashboard';

export function Sidebar() {
  const { logout } = useAuth();
  const { view, setView, lastRefresh } = useDashboard();

  const age = lastRefresh
    ? `${Math.round((Date.now() - lastRefresh.getTime()) / 1000)}s ago`
    : 'loading...';

  return (
    <aside
      data-testid="ops-sidebar"
      className="hidden md:flex flex-col w-60 lg:w-72 border-r border-slate-800 bg-slate-950/80 p-4 gap-4"
    >
      <div className="mb-4">
        <h1 className="text-sm font-bold text-slate-200 tracking-wide">OPS NOC</h1>
        <p className="text-xs text-slate-400 mt-0.5">ForceShield Operations</p>
      </div>
      <nav className="flex flex-col gap-1">
        {(['health', 'incidents'] as const).map((v) => (
          <button
            key={v}
            data-testid={`ops-sidebar-nav-${v}`}
            onClick={() => setView(v)}
            className={`text-left px-3 py-2 rounded-lg text-xs capitalize transition-colors ${
              view === v
                ? 'bg-slate-800 text-slate-200 font-medium'
                : 'text-slate-400 hover:text-slate-200 hover:bg-slate-800/50'
            }`}
          >
            {v}
          </button>
        ))}
      </nav>
      <div className="mt-auto text-xs text-slate-400">
        <p>Last refresh: {age}</p>
        <button
          data-testid="ops-sidebar-logout"
          onClick={logout}
          className="text-slate-400 hover:text-slate-200 mt-2"
        >
          Sign out
        </button>
      </div>
    </aside>
  );
}
